/* eslint-disable react/no-array-index-key */
/* eslint-disable security/detect-object-injection */
/* eslint-disable camelcase */
import React, { useState, useMemo, useRef, useEffect } from "react";
import { Avatar, Select, MenuItem, Box, Tooltip, Chip,} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import AddIcon from "@mui/icons-material/Add";
import BackgroundWrapper from "components/Background";
import { Delete, Edit, GreenTick, RedCancel, SearchDropdownIcon,SearchIcon } from "assets/images/icons";
import { useAppDispatch, useAppSelector } from "hooks/store-hooks";
import { ENDPOINTS } from "constants/constant";
import client from "client";
import { createPortal } from "react-dom";
import Loading from "components/Loading";
import { setOutletLoading, setUserInfoDetails } from "store/slice/userSlice";
import { getAccountInfo } from "constants/common";
import { setActiveTab } from "store/slice/conversationSlice";
import { useNavigate } from "react-router-dom";

export const avatarColors = [
  "#EACBCB", "#C2CAE6", "#E3DEB4", "#D3E6CF", "#BEE2E9",
  "#E5CEF0", "#FBE6C8", "#ABCAB2", "#D8CBE9", "#DFE9CB",
  "#F7D6E0", "#F9E3D5", "#FBEACB", "#F9F3C6", "#E8F4C8",
  "#D4F2D2", "#C8EFE5", "#C4E9F5", "#D5D2F7", "#E7D3F3",
  "#F5D0D0", "#F7DDC7", "#F8E7B8", "#F3F5C4", "#DDF2C8",
  "#C9EFD7", "#BEECE7", "#C3E4F2", "#D2D0F6", "#E6D2F1",
  "#F4C2C2", "#F6D7B9", "#F7E3A8", "#EEF1BC", "#D5EEC3",
  "#C2EBCF", "#B3E5DF", "#BEDCF0", "#CDC9F2", "#E1CCE9",
  "#F2BFBF", "#F4D3B0", "#F7DEA2", "#EBEEB5", "#CEEABF",
  "#BAE6CB", "#AEE1D8", "#B9D8EE", "#C7C5F0", "#DDC7E7",
  "#F0BABA", "#F3CFA5", "#F6DA98", "#E7EAAE", "#C8E8BA",
  "#B5E3C8", "#A3DEC5", "#B4D4EA", "#C3C2EE", "#D8C3E3",
  "#EEB5B5", "#F0CAA1", "#F2D793", "#E3E6A6", "#C2E2B4",
  "#ADDEC1", "#9CD9C3", "#A9CEE6", "#BFC0EC", "#D3BDE0",
  "#ECB0B0", "#EEC59A", "#F0D28D", "#DFE3A0", "#BCE0AE",
  "#A8DBBC", "#93D5BE", "#A5CAE3", "#BABBE8", "#CEB7DD",
  "#E9ACAC", "#ECC095", "#EDCF87", "#DADE9A", "#B6DCA8",
  "#A2D7B5", "#8DD2BA", "#9EC7E0", "#B5B6E4", "#C9B2DA",
  "#E7A7A7", "#EABC8F", "#EACA82", "#D6DA93", "#B0D8A2",
  "#9CD3B0", "#88CEB7", "#97C4DE", "#B0B1E2", "#C4ABD8",
  "#E4A2A2", "#E8B789", "#E7C67C", "#D2D68D", "#AAD39C",
  "#95CEAA", "#82CAB3", "#91BFDA", "#AAAADE", "#BFA6D5"
];

  // --- MultiSelect Dropdown Helpers ---
 function useClickOutside(ref: React.RefObject<HTMLElement>, handler: () => void) {
      useEffect(() => {
          const onClick = (e: MouseEvent) => {
              if (!ref.current) return;
              if (!ref.current.contains(e.target as Node)) handler();
          };
          document.addEventListener("mousedown", onClick);
          return () => document.removeEventListener("mousedown", onClick);
      }, [ref, handler]);
  }

// Sub-component for individual rows
function DomainItem({
  item,
  checked,
  onToggle,
}: {
  item: any;
  checked: boolean;
  onToggle: () => void;
}) {
  return (
    <label className="group flex items-start gap-3 px-2 py-2 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-all duration-150 select-none">
      {/* Checkbox */}
      <div className="pt-1">
        <div
          className={`w-4 h-4 border rounded flex items-center justify-center transition-all duration-200 ${
            checked
              ? "bg-[#F7901D] border-[#F7901D]"
              : "border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 group-hover:border-[#F7901D]"
          }`}
        >
          {checked && (
            <svg
              className="w-3 h-3 text-white"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M16.704 6.207a1 1 0 00-1.414-1.414L9 10.172 5.707 6.879a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7z"
                clipRule="evenodd"
              />
            </svg>
          )}
        </div>
        <input
          type="checkbox"
          checked={checked}
          onChange={onToggle}
          className="hidden"
        />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
            {/* <DomainIcon className="w-3.5 h-3.5 text-gray-400" /> */}
            <span
            className={`text-[13px] font-medium truncate ${
                checked ? "text-[#F7901D]" : "text-[#312E2D] dark:text-gray-200"
            }`}
            >
            {item.value}
            </span>
        </div>
        
        <p className="text-[11px] text-gray-500 dark:text-gray-400 mt-0.5 truncate">
          {item.description}
        </p>
      </div>
    </label>
  );
}

  function MultiSelectDropdown({ allDomains, value, onChange }: {allDomains :any[] , value: string[], onChange: (ids: string[]) => void; }) {
      const [open, setOpen] = useState(false);
      const [q, setQ] = useState("");
      const [anchorRect, setAnchorRect] = useState<DOMRect | null>(null);
      // const { selectedDomain } = useAppSelector((s) => s.user);
      // const formattedDomain = selectedDomain.replace(/_/g, ' ').split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
      const containerRef = useRef<HTMLDivElement | null>(null);
      // useClickOutside(containerRef, () => setOpen(false));
  
      console.log(value,'all domains')
      // const filtered = allUsers.filter(
      //     (u) => u.name.toLowerCase().includes(q.toLowerCase())
      // );
  
    // Filter based on Search Query
    const filteredAll = useMemo(() => 
       allDomains.filter(
        (d) =>
          d.value.toLowerCase().includes(q.toLowerCase()) ||
          d.description.toLowerCase().includes(q.toLowerCase())
      ), [allDomains, q]);

    // 2. Split into "Selected" and "Not Selected" sections
   const selectedItems = filteredAll.filter((d) => value.includes(d.id));
   const unselectedItems = filteredAll.filter((d) => !value.includes(d.id));



      function toggle(id: string) {
          if (value.includes(id)) onChange(value.filter((v) => v !== id));
          else onChange([...value, id]);
      }
  
      function clearAll() {
          onChange([]);
      }
  
      // function selectAll() {
      //     onChange([filtered.map((u) => u.id)].flat());
      // }
  
    function selectAll() {
      // Selects all visible (filtered) items that aren't already selected
      // const newIds = unselectedItems.map((d) => d.id);
      // const combined = [...value, ...newIds];
      // Remove duplicates just in case
      onChange([filteredAll.map((u) => u.id)].flat());
      // onChange([...new Set(combined)]);
    }

      return (
          <div className="relative w-full max-w-[224px] " ref={containerRef}>
              {/* Input area (chips) */}
              <button
                  type="button"
                  aria-haspopup="listbox"
                  aria-expanded={open}
                  onClick={(e) => {
                    const rect = e.currentTarget.getBoundingClientRect();
                    setAnchorRect(rect);
                    setOpen((s) => !s);
                  }}
                  className="w-full max-w-[300px] bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-[6px] px-3 py-1.5 flex items-center justify-between gap-2 h-[32px] focus:outline-none focus:ring-1 focus:ring-[#F7901D] transition-all duration-150 "
              >
                  {/* LEFT: selected users or placeholder */}
                  <div className="flex items-center gap-2 overflow-x-auto scrollbar-none flex-1 min-w-0">
                      {value.length === 0 ? (
                          <span className="text-[12px] text-[#988F8C] whitespace-nowrap">Enter Domain</span>
                      ) : (
                          value.map((id) => {
                              const domain = allDomains.find((x) => x.id === id);
                              if (!domain) return null;
                              return (
                                  <div
                                      key={id}
                                      className="flex items-center gap-1 bg-[#FCE3C7] dark:bg-[#2B2B2B] rounded-[6px] px-2 py-[2px] shrink-0"
                                  >
                                      {/* <Avatar user={u} size={18} /> */}
                                      <span className="text-[12px] text-[#312E2D] dark:text-gray-200 truncate max-w-[80px]">{domain.value}</span>
                                      <button
                                          type="button"
                                          onClick={(e) => {
                                              e.stopPropagation();
                                              // onChange(value.filter((v) => v !== id));
                                              toggle(id);
                                          }}
                                          aria-label={`Remove ${domain.id}`}
                                          className="ml-1 text-gray-500 hover:text-[#F7901D] transition-colors"
                                      >
                                          <svg
                                              className="w-3 h-3"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              strokeWidth="2"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                          >
                                              <line x1="18" y1="6" x2="6" y2="18" />
                                              <line x1="6" y1="6" x2="18" y2="18" />
                                          </svg>
                                      </button>
                                  </div>
                              );
                          })
                      )}
                  </div>
  
                  {/* RIGHT: dropdown arrow */}
                  <svg
                      className={`w-4 h-4 text-gray-400 flex-shrink-0 transform transition-transform duration-150 ${open ? "rotate-180" : ""
                          }`}
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden
                  >
                      <path
                          fillRule="evenodd"
                          d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 011.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                          clipRule="evenodd"
                      />
                  </svg>
              </button>
  
  
              {/* Dropdown Menu */}
          {open && anchorRect && createPortal(
            <div
              style={{
                // position: "fixed",
                top: anchorRect.bottom + 4,
                left: anchorRect.left,
                // width: anchorRect.width,
                // zIndex: 9999,
              }}
              className="absolute z-[9999] w-[300px] bg-white shadow-2xl rounded-lg"
            >
                  <div className=" z-[9999] mt-[2px] w-[min(28rem,100%)] max-w-[300px] right-0 left-0 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-2xl p-3">
                      <div className="flex items-center bg-bottom gap-3 pb-3 ">
                          <SearchDropdownIcon className="absolute ml-[10px]" />
                          <input
                              type="text"
                              value={q}
                              onChange={(e) => setQ(e.target.value)}
                              placeholder="Search"
                              className="flex-1 text-[#000000] pl-7 rounded-[6px] px-3 py-2 text-[12px] bg-[#F4F4F4] border-none dark:bg-gray-900 focus:outline-none focus:ring-1 focus:ring-orange-400"
                              aria-label="Search Domain"
                          />
  
                      </div>
                      <div className="flex flex-inline">
                          <p className="text-[#312E2D] text-[12px]">Domain ({filteredAll.length.toString().padStart(2, "0")})</p>
                          {value.length > 0 ? (<button type="button"
                              onClick={clearAll}
                              className="ml-[58%] text-[12px] text-[#F7901D] font-medium hover:text-orange-600 transition-colors disabled:opacity-50"
  
                          >
                              Clear All
                          </button>) :
                              (<button type="button"
                                  onClick={selectAll}
                                  className="ml-[58%] text-[12px] text-[#F7901D] font-medium hover:text-orange-600 transition-colors disabled:opacity-50"
  
                              >
                                  Select All
                              </button>)}
                      </div>
  
                      <div className="max-h-60 overflow-y-auto space-y-1 pt-2">
                          {filteredAll.length === 0 && <div className="text-[12px] text-gray-500 py-3 text-center">No matching domains found.</div>}
                          {/* {filteredAll.map((u) => {
                              const checked = value.includes(u.id);
                              return (
                                  <label
                                      key={u.id}
                                      className="flex items-center gap-3 px-3 py-2 rounded-lg cursor-pointer transition-all duration-100"
                                  >
                                     
                                      <div
                                          className="w-[12px] h-[12px] border-2 flex-none transition-all duration-150 flex items-center justify-center"
                                          style={{
                                              borderColor: checked ? "#F7901D" : "#CCC",
                                              backgroundColor: checked ? "#F7901D" : "transparent",
                                          }}
                                      >
                                          {checked && <svg className="w-3 h-3 text-white" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M16.704 6.207a1 1 0 00-1.414-1.414L9 10.172 5.707 6.879a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l7-7z" clipRule="evenodd" /></svg>}
                                      </div>
                                      <input
                                          type="checkbox"
                                          checked={checked}
                                          onChange={() => toggle(u.id)}
                                          className="hidden" 
                                          aria-checked={checked}
                                      />
  
  
                                      <div className="flex-1 text-[12px] overflow-hidden">
                                          <div className=" text-[#312E2D] dark:text-gray-100 leading-4 truncate ">
                                              {u.value}
                                          </div>
                                      </div>
                                  </label>
                              );
                          })} */}
                          {/* SECTION 1: Selected Items */}
            {selectedItems.length > 0 && (
              <div className="mb-2">
                <div className="text-[10px] font-bold text-gray-400 uppercase px-2 mb-1">
                  Selected ({selectedItems.length})
                </div>
                {selectedItems.map((u) => (
                  <DomainItem
                    key={u.id}
                    item={u}
                    checked
                    onToggle={() => toggle(u.id)}
                  />
                ))}
              </div>
            )}

            {/* Separator if both exist */}
            {selectedItems.length > 0 && unselectedItems.length > 0 && (
              <div className="h-px bg-gray-100 dark:bg-gray-700 my-2 mx-2" />
            )}

            {/* SECTION 2: Unselected Options */}
            {unselectedItems.length > 0 && (
              <div>
                {unselectedItems.map((u) => (
                  <DomainItem
                    key={u.id}
                    item={u}
                    checked={false}
                    onToggle={() => toggle(u.id)}
                  />
                ))}
              </div>
            )}
                      </div>
                  </div>
                  </div>,
              document.body
            )
              }
          </div>
      );
  };

  function DomainRenderer({ domains }: { domains: any[] }) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [visibleCount, setVisibleCount] = useState(domains.length || 0);

  const formatDomain = (domain:any) =>
  domain
    .replace(/_/g, " ")
    .replace(/\band\b/g, "&")
    .replace(/\b\w/g, (c:any) => c.toUpperCase());

  const formattedDomains = useMemo(
    () => domains.map(formatDomain),
    [domains]
  );

  useEffect(() => {
    if (!containerRef.current) return;

    const containerWidth = containerRef.current.offsetWidth;
    // let usedWidth = 0;
    let count = 0;

    const tempSpan = document.createElement("span");
    tempSpan.style.visibility = "hidden";
    tempSpan.style.position = "absolute";
    tempSpan.style.whiteSpace = "nowrap";
    tempSpan.style.fontSize = "12px";
    document.body.appendChild(tempSpan);

   for (let i = 0; i < formattedDomains.length; i += 1) {
  const text = `${formattedDomains.slice(0, i + 1).join(", ")}, +99 more`;

  tempSpan.innerText = text;

  if (tempSpan.offsetWidth > containerWidth) break;
  count = i + 1;
}

    document.body.removeChild(tempSpan);
    setVisibleCount(Math.max(1, count));
  }, [formattedDomains]);

  const visible = formattedDomains.slice(0, visibleCount);
  const remaining = formattedDomains.slice(visibleCount);

  return (
    <Box
      ref={containerRef}
      sx={{
        fontSize: "12px",
        color: "#312E2D",
        whiteSpace: "nowrap",
        overflow: "hidden",
      }}
    >
      {visible.join(", ")}

      {remaining.length > 0 && (
        <>
          {", "}
          <Tooltip
            arrow
            placement="top"
            title={
              <Box sx={{ display: "flex", background: "#707070", color: "#FFFFFF", flexDirection: "column", gap: 0.5,paddingX: '10px', paddingY:1 }}>
                {remaining.map((d) => (
                  <span className="text-[12px]" key={d}>{d}</span>
                ))}
              </Box>
            }
          >
            <span
              style={{
                color: "#F7901D",
                cursor: "pointer",
                fontWeight: 400,
              }}
            >
              +{remaining.length} more
            </span>
          </Tooltip>
        </>
      )}
    </Box>
  );
};



function Users() {
  const EMPTY_NEW_USER = {
    name: "",
    username: "",
    user_type: "",
    domain_name: [],
    account_status: "Active",
  };

  const ROLE_OPTIONS = [
    "External",
    "Internal",
    "Sso"
  ];

  const [isAdding, setIsAdding] = useState(false);
  const navigate = useNavigate();
  const [newUser, setNewUser] = useState(EMPTY_NEW_USER);
  const [users, setUsers] = useState([{ },]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const { activeChatId, activeChatDetails, outletLoading, user_id, name, selectedDomain } = useAppSelector((s) => s.user);
  const [selectedDomains, setSelectedDomain] = useState<string[]>([]);
  const [editingId, setEditingId] = useState<number | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [editForm, setEditForm] = useState<any>({});
  const [domainList, setDomainList] = useState([]);
  const dispatch = useAppDispatch();
  const [confirming, setConfirming] = useState<string | null>(null);

  const startEdit = (user: any) => {
    setEditingId(user.username);
    setEditForm(user);
  };

  const getDataFromAPI: any = async () => {
    try {
      const response = await client.post(ENDPOINTS.domainNames, { username: user_id });
      const resValue = response.data;
      return resValue;
    } catch (error) {
      // console.error("Error fetching data :", error);
      return null;
    }
  };

  const getUsersData: any = async () => {
    try {
      dispatch(setOutletLoading(true));
      const response = await client.get(ENDPOINTS.getUsersList);
      const resValue = response.data;
      if (resValue.status) {
            console.log("Users List Data:", resValue.user_details);
            setUsers(resValue.user_details)
            dispatch(setOutletLoading(false));
            
      }else{
        dispatch(setOutletLoading(false));
      }
    } catch (error) {
      dispatch(setOutletLoading(false));
      // console.error("Error fetching data :", error);
    }
    try{
      const accountInfoPayload: any = {
            username: user_id,
    }
    const accountInfoResponse = await getAccountInfo(accountInfoPayload);
          if (accountInfoResponse?.data) {
            dispatch(setUserInfoDetails(accountInfoResponse.data));
            navigate('/users');
            dispatch(setActiveTab('Users'))
           }
  }
    catch (error) {
        // console.error("Error fetching data :", error);
    }
    
  }

  useEffect(() => {
    getDataFromAPI().then((data: any) => {
      console.log("Domain List Data:", data);
      if (data.length > 0) {
        setDomainList(data);
      }
    })
    getUsersData()
    
    
  }, []);

    // const [debouncedSearch, setDebouncedSearch] = useState(search);
    // useEffect(() => {
    //   const t = setTimeout(() => setDebouncedSearch(search), 150);
    //   return () => clearTimeout(t);
    // }, [search]);


    const filteredUsers = useMemo(() => {
    let data = [...users];


      if (search.trim()) {
        const s = search.toLowerCase();

        data = data.filter((u: any) => {
          const name = u.name?.toLowerCase() || "";
          const username = u.username?.toLowerCase() || "";

          return name.includes(s) || username.includes(s);
        });
      }
      else{
        data = [...users];
      }


    if (statusFilter !== "All") {
      data = data.filter((u:any) => u.account_status === statusFilter);
    }

    return data;
  }, [users, search, statusFilter]);


  const cancelEdit = () => {
    setEditingId(null);
    setEditForm({});
  };

  const saveEdit = () => {
    setUsers((prev:any) =>
      prev.map((u:any) => (u.username === editingId ? editForm : u))
    );
    setEditingId(null);
  };

  const onDelete = async (user: any) => {
  
          try {
              dispatch(setOutletLoading(true))
              const deletePayload: any = {
                username: user.username,
              }
  
              const deleteResponse = await client.post(ENDPOINTS.deleteUser, deletePayload);
              if (deleteResponse.data.status) {
                  // remove from users
                  setUsers((prev) => prev.filter((u:any) => u.username !== user.username));
              }
  
          }
          catch (error) {
              dispatch(setOutletLoading(false))
          } finally {
              dispatch(setOutletLoading(false))
          }
  
  
      };

  const handleEditChange = (field: string, value: any) => {
    setEditForm((prev:any) => ({ ...prev, [field]: value }));
  };

  const getAvatarLetter = (name:any) => {
  if (!name) return "U";

  return name.trim()[0]?.toUpperCase() || "U";
};




  return (
    <BackgroundWrapper>
      {/* HEADER */}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-6 gap-4">
        <h1 className="text-[18px] font-semibold pt-5 pl-5 text-[#000000]">Users</h1>

        <div className="flex flex-col sm:flex-row pt-5 gap-4 w-full lg:w-auto mr-4">

          {/* Search Input */}
          <div className="px-1 mb-[-1] border-b border-gray-500 ">
            <div className="flex items-center bg-bottom rounded w-full">
              <SearchIcon className="w-4 h-4 text-gray-500 mr-1" />
              <input
                ref={inputRef}
                autoComplete="off"
                autoCorrect="off"
                spellCheck={false}
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search"
                style={{ background: "bottom",padding: "4px 2px 4px 0px" }}
                className="w-full border-none text-[12px] focus:outline-none"
              />
            </div>
          </div>

          {/* Status Filter */}
          <div className="flex items-center gap-2">
            <span className="text-gray-500 text-[12px] leading-none">
              Sort By:
            </span>

            <Select
              value={statusFilter}
              size="small"
              onChange={(e) => setStatusFilter(e.target.value)}
              className="text-[12px]"
              IconComponent={ArrowDropDownIcon}
              sx={{
                height: 24,
                borderRadius: "6px",
                fontSize: "12px",
                backgroundColor: "none",
                "& .MuiSelect-select": {
                  padding: "4px 8px 4px 8px",
                },
                "& fieldset": {
                  border: "none",
                },
              }}
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </Select>
          </div>

        </div>
      </div>

      {/* TABLE CONTAINER */}
   <div className="bg-white rounded-xl mx-[20px] shadow-sm relative ">

  <div className="px-[20px] overflow-x-auto overflow-y-auto max-h-[614px]">

    <table className="w-full table-fixed text-left min-w-[900px]">
      <thead className="sticky top-0 z-20 ">
        <tr className="border-b border-[#7C7C7C] bg-white">
          <th className="pt-4 pb-2 px-3 text-[14px] font-semibold text-[#312E2D]">
            User Name
          </th>
          <th className="pt-4 pb-2 px-3 text-[14px] font-semibold text-[#312E2D]">
            Email
          </th>
          <th className="pt-4 pb-2 px-3 text-[14px] font-semibold text-[#312E2D]">
            Role
          </th>
          <th className="pt-4 pb-2 px-3 text-[14px] font-semibold text-[#312E2D]">
            Domain
          </th>
          <th className="pt-4 pb-2 px-3 text-[14px] font-semibold text-[#312E2D]">
            Status
          </th>

          <th
            aria-label="Act"
            className="pt-4 pb-2 px-2 w-[1%] whitespace-nowrap text-right font-semibold text-[#312E2D]"
          />
        </tr>
      </thead>

      <tbody>

        {isAdding && (
  <tr className="bg-[#FFF8EC] border-b border-dashed border-[#DADADA]">
    {/* NAME */}
    <td className="px-3 py-3">
      <input
      aria-label=" name"
        className="w-full text-[12px] border rounded px-2 py-1"
        placeholder="Enter Name"
        value={newUser.name}
        onChange={(e) =>
          setNewUser((u) => ({ ...u, name: e.target.value }))
        }
      />
    </td>

    {/* USERNAME */}
    <td className="px-3 py-3">
      <input
      aria-label="User name"
        className="w-full text-[12px] border rounded px-2 py-1"
        placeholder="Enter Email ID"
        value={newUser.username}
        onChange={(e) =>
          setNewUser((u) => ({ ...u, username: e.target.value }))
        }
      />
    </td>

    {/* ROLE */}
    <td className="px-3 py-3">
      <Select
        size="small"
        value={newUser.user_type}
        onChange={(e) =>
          setNewUser((u) => ({ ...u, user_type: e.target.value }))
        }
        displayEmpty
        sx={{
                        height: 28,
                        fontSize: "12px",
                        borderRadius: "6px",
                        backgroundColor: "#FAFAFA",
                        "& .MuiSelect-select": {
                          padding: "4px 28px 4px 10px",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& fieldset": {
                          borderColor: "#E0E0E0",
                        },
                        "&:hover fieldset": {
                          borderColor: "#C4C4C4",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#F7901D",
                        },
                      }}
      >
        <MenuItem value="" disabled>
          Enter role
        </MenuItem>
        {ROLE_OPTIONS.map((r) => (
          <MenuItem key={r} value={r} sx={{ fontSize: "12px" }}>
            {r}
          </MenuItem>
        ))}
      </Select>
    </td>

    {/* DOMAIN */}
    <td className="px-3 py-3">
      <MultiSelectDropdown
        allDomains={domainList}
        value={newUser.domain_name}
        onChange={(value) =>
          setNewUser((u:any) => ({ ...u, domain_name: value }))
        }
      />
    </td>

                  {/* STATUS */}
                  <td className="px-3 py-3">
                    <Select
                      size="small"
                      value={newUser.account_status}
                      onChange={(e) =>
                        setNewUser((u) => ({
                          ...u,
                          account_status: e.target.value,
                        }))
                      }
                      sx={{
                        height: 28,
                        fontSize: "12px",
                        borderRadius: "6px",
                        backgroundColor: "#FAFAFA",
                        "& .MuiSelect-select": {
                          padding: "4px 28px 4px 10px",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& fieldset": {
                          borderColor: "#E0E0E0",
                        },
                        "&:hover fieldset": {
                          borderColor: "#C4C4C4",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#F7901D",
                        },
                      }}
                    >
                      <MenuItem value="Active" sx={{ fontSize: "12px" }}>Active</MenuItem>
                      <MenuItem value="Inactive" sx={{ fontSize: "12px" }}>Inactive</MenuItem>
                    </Select>
                  </td>

                  {/* ACTIONS */}
                  <td className="px-3 py-3 text-right">
                    <div className="flex justify-end gap-3 items-center mr-[5px] whitespace-nowrap">
                      <div  className="flex items-center cursor-pointer mr-[12px]"
                        onClick={() => {
                          // onCreateUser(newUser); // API / state update
                          setIsAdding(false);
                        }}     >
                        <GreenTick />
                      </div>

                      <div className="cursor-pointer  mr-[10px]"
                        onClick={() => setIsAdding(false)}    >
                        <RedCancel />
                      </div>
                    </div>
                  </td>
                </tr>
              )}

        {filteredUsers.map((user:any, index) => {
          const isEditing = editingId === user.username;
          const color = avatarColors[index % avatarColors.length];

          return (
            <>
            <tr
              key={user.username}
              className={`border-b border-dashed border-[#DADADA] transition group
                ${isEditing ? "bg-orange-50" : "hover:bg-[#FDF7E7]"}
                ${user.account_status === "Inactive" ? "opacity-60" : "opacity-100"}`}
            >
              {/* USER */}
              <td className="pt-4 pb-4 px-3 max-w-0 truncate">
                <div className="flex items-center gap-3">
                  <Avatar
                    sx={{
                      color: "#312E2D",
                      width: 24,
                      height: 24,
                      bgcolor: color,
                      fontSize: 10,
                    }}
                  >
                    {getAvatarLetter(user.name)}
                  </Avatar>
                  <span className="text-[12px] text-[#312E2D] truncate">
                    {user.name || "User"}
                  </span>
                </div>
              </td>

              {/* EMAIL */}
              <td className="pt-4 pb-4 px-3 text-[12px] text-[#312E2D] max-w-0 truncate">
                {user.username}
              </td>

              {/* ROLE */}
              <td className="pt-4 pb-4 px-3 text-[12px] max-w-0 truncate">
                {user.user_type}
              </td>

              {/* DOMAIN */}
              <td className="pt-4 pb-4 px-3 text-[12px] text-[#312E2D] max-w-0 truncate overflow-visible">
                {isEditing ? (

                  <MultiSelectDropdown allDomains={domainList} value={user.domain_name} 
                  onChange={(value) =>
                   setNewUser((u:any) => ({ ...u, domain_name: value }))} 
                   />
                  
                ) : (
                  // user.domain_name
                  <DomainRenderer domains={user.domain_name || []} />
                )}
              </td>

              {/* STATUS */}
              <td className="pt-4 pb-4 px-3 text-[12px] text-[#312E2D] max-w-0 truncate">
                {isEditing ? (
                    <Select
                      size="small"
                      value={editForm.account_status}
                      onChange={(e) =>
                        handleEditChange("account_status", e.target.value)
                      }
                      sx={{
                        height: 28,
                        fontSize: "12px",
                        borderRadius: "6px",
                        backgroundColor: "#FAFAFA",
                        "& .MuiSelect-select": {
                          padding: "4px 28px 4px 10px",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& fieldset": {
                          borderColor: "#E0E0E0",
                        },
                        "&:hover fieldset": {
                          borderColor: "#C4C4C4",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#F7901D",
                        },
                      }}
                    >
                      <MenuItem value="Active" sx={{ fontSize: "12px" }}>
                        Active
                      </MenuItem>
                      <MenuItem value="Inactive" sx={{ fontSize: "12px" }}>
                        Inactive
                      </MenuItem>
                    </Select>

                ) : (
                  <span
                    className={`px-3 py-1 text-[12px] rounded 
                      ${
                        user.account_status === "Active"
                          ? "bg-[#E8F7EB] text-[#24993F]"
                          : "bg-[#EEEEEE] text-[#312E2D]"
                      }`}
                  >
                    {user.account_status}
                  </span>
                )}
              </td>

              {/* ACTIONS */}
              <td className="pt-4 pb-4 px-1 w-[1%] whitespace-nowrap text-right">
                {isEditing ? (
                  <div className="flex justify-end gap-3 items-center mr-[5px] whitespace-nowrap"  >
                    <div  className="flex items-center cursor-pointer mr-[11px]" onClick={ saveEdit}  >
                      <GreenTick />
                    </div>
                    <div className="cursor-pointer mr-[3px]" onClick={cancelEdit } >
                      <RedCancel />
                    </div>
                  </div>
                ) : confirming !== user.username ? (
                  <div
                    className="flex justify-end gap-3 items-center 
                      group-hover:opacity-100 pointer-events-none mr-[5px]
                      group-hover:pointer-events-auto whitespace-nowrap"
                  >
                    <div
                      className="flex items-center cursor-pointer"
                      onClick={() => startEdit(user)}
                    >
                      <Edit />
                      <span className="text-[#f7901d] text-[12px] ml-[7px]">
                        Edit
                      </span>
                    </div>

                    <span className="border-r h-[13px] mt-[1px] border-[#707070]" />

                    <div className="cursor-pointer"
                      onClick={() => setConfirming((s:any) => (s === user.username ? null : user.username))} >
                      <Delete />
                    </div>
                      
                    </div>
                ): null}
              </td>
            </tr>
            
              {/* Inline confirmation row */}
              {confirming === user.username && (
                <tr className="bg-[#FCEECE] animate-in fade-in slide-in-from-top-1">
                  <td colSpan={6} className="px-6 py-3">
                    <div className="flex items-center justify-between w-full">
                      <div className="text-[12px] text-[#312E2D]">
                        {user.account_status === 'Active'?'This action will permanently delete the user. For temporary removal, set status to inactive.':
                        'This action will permanently delete the user.'}
                      </div>

                      <div className="flex items-center gap-2">
                        <button
                          type="button"
                          onClick={() => setConfirming(null)}
                          className="px-3 py-1 text-[12px] text-[#8D8D8D]"
                        >
                          Cancel
                        </button>

                        <button
                          type="button"
                          onClick={() => {
                            onDelete(user);
                            setConfirming(null);
                          }}
                          className="px-4 py-1 rounded-[16px] bg-[#DB0007] text-white text-[12px]"
                        >
                          Confirm
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              )}


            </>
          );
        })}

        {filteredUsers.length === 0 && (
          <tr>
            <td colSpan={6} className="py-10 text-center text-gray-400 text-[12px]">
              No users found.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>

  {/* FAB Button */}
  <button
    type="button"
    onClick={() => {
    setIsAdding(true);
    setNewUser(EMPTY_NEW_USER);
  }}
    className="absolute bottom-6 right-6 w-12 h-12 bg-[#F7901D] hover:bg-[#F7901D] rounded-full flex items-center justify-center shadow-lg text-white"
  >
    <AddIcon />
  </button>
</div>
{outletLoading && (
              <>
                <div className="absolute inset-0 backdrop-blur-sm z-20" />
                <div className="absolute inset-0 flex items-center justify-center z-30">
                  <Loading />
                </div>
              </>
            )}

    </BackgroundWrapper>
  );
}

export default Users;
